import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { LoggerService } from './LoggerService';

@Injectable()
export class RoleService {

  constructor() { }

  readonly isTL = environment.verroFiche.permissionsUser.indexOf(this.getConnectedUserRole()) == 0;
  readonly isOps = environment.verroFiche.permissionsUser.indexOf(this.getConnectedUserRole()) == 1;
  readonly isBUM = environment.verroFiche.permissionsUser.indexOf(this.getConnectedUserRole()) == 2;
  readonly isDS = environment.verroFiche.permissionsUser.indexOf(this.getConnectedUserRole()) == 3;

  getConnectedUserRole(){
    const  authorities  = JSON.parse(localStorage.getItem(environment.oauth.remoteUser)) && JSON.parse(localStorage.getItem(environment.oauth.remoteUser)).authorities;
    const roles = authorities && authorities.filter(e => e.clientId == 'myshift2').map(e => e.authority);
    return roles && roles.filter(role => role && environment.verroFiche.permissionsUser.indexOf(role) > -1)[0];
  }

  getConnectedUserRoleByCriterion(filter : (E) => boolean){
    const  authorities  = JSON.parse(localStorage.getItem(environment.oauth.remoteUser)) && JSON.parse(localStorage.getItem(environment.oauth.remoteUser)).authorities;
    const roles = authorities && authorities.filter(e => e.clientId == 'myshift2').map(e => e.authority);
    return  roles && roles.filter(filter)[0];
  }

  isFormationRelatedRoleFilter = (role) => role && environment.formationRelatedRoles.indexOf(role) > -1;

  getisFormationRelatedRole = () => this.getConnectedUserRoleByCriterion(this.isFormationRelatedRoleFilter);
}



// WEBPACK FOOTER //
// ./src/app/service/RoleService.ts